import { Box } from '@chakra-ui/react';
import React from 'react';
import { Close } from '../../Icons/Close';
import { CommonProps } from '../../interfaces/components';
// import Background from '../assets/images/ac_badge.png';
import ReactPlayer from 'react-player';

const AcPDP = ({ active, setActive }: CommonProps) => {
  // const [showContent, setShowContent] = useState(false);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setShowContent(active);
  //   }, 250);
  // }, [active]);

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        // transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding="0px"
        width={['380px', '400px', '380px', '380px', '380px']}
        h={['675px', '710px', '670px']}
        // height={['760px', '800px', '702px', '702px', '702px']}
      >
        <Close
          boxSize={[5, 5, 6]}
          position="absolute"
          top={['30px', '30px', '35px']}
          right={['30px', '30px', '35px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        {active && (
          <ReactPlayer
            progressInterval={1}
            height="auto"
            width="100%"
            loop={true}
            muted
            controls={false}
            playing={active}
            url="https://emperia-static.s3.eu-west-2.amazonaws.com/client/bister/laroca/open_creative_gallery.mov"
            playsinline
          />
        )}
        {/* <Box
          position="absolute"
          bottom="0px"
          left="0"
          w={['100%', '100%', '100%', '100%']}
          h={['75px', '75px', '80px', '100px']}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Text
            fontWeight="400"
            fontSize={['14px', '14px', '14px', '16px', '16px']}
            lineHeight={['18px', '18px', '18px', '20px', '20px']}
            maxW="240px"
            textAlign="center"
            className="copy"
            fontFamily="JosefinSans"
          >
            Enjoy Arts & Culture initiatives at La Roca Village
          </Text>
        </Box> */}
      </Box>
    </>
  );
};

export default AcPDP;
